// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.crypto.wallet",
    name: "Crypto.com | DeFi Wallet",
    homepage: "https://crypto.com/",
    image_id: "88388eb4-4471-4e72-c4b4-852d496fea00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/US/app/id1512048310?mt=8",
        android: "https://play.google.com/store/apps/details?id=com.defi.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/cryptocom-wallet-extensio/hifafgmccdpekplomjjkcfgodnhcellj",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.crypto.wallet",
    mobile: {
        native: "dfw://",
        universal: "https://wallet.crypto.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map